<style lang="postcss">
	.choice-option {
		padding: 0.5rem 0.65rem;
	}
	.choice-option.opacity-true .choice-option-content {
		opacity: 0.8;
	}

	.choice-option.active .choice-option-content {
		opacity: 1;
	}

	.choice-option.descriptions .choice-option-text-main {
		font-weight: 500;
	}

	.choice-option.active {
		box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
	}

	.choice-option.vertical.active {
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
	}

	.choice-option-content {
		display: flex;
		flex: 1 1 auto;
		width: 100%;
	}
	.choice-option.horizontal .choice-option-content {
		flex-direction: row;
		align-items: center;
	}
	.choice-option.vertical .choice-option-content {
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 0.3rem 0;
		gap: 0.5rem;
	}

	.choice-option-text {
		width: 100%;
		font-size: 92.5%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		justify-content: center;
		overflow-wrap: break-word;
		font-weight: 430;
	}

	.choice-option.descriptions .choice-option-text {
		font-size: 95%;
	}

	.choice-option-text-description {
		font-size: 0.85rem;
		line-height: 1.5;
		padding-top: 0.1em;
	}

	.choice-option-text-description :global(ul) {
		margin: 0.1rem 0;
		padding-left: 0.8rem;
		list-style-type: disc;
	}
	.choice-option-text-description :global(li) {
		padding: 0.1em 0;
		margin: 0;
	}
	.choice-option-text-description :global(p) {
		margin: 0.1em 0;
	}

	.choice-option.horizontal .choice-option-text {
		margin-left: 0.35rem;
		text-align: left;
	}

	.choice-option.descriptions.horizontal.wide .choice-option-text {
		margin-left: 0.65rem;
	}

	.choice-option.vertical .choice-option-text {
		text-align: center;
	}

	/* Checkmark cover */
	.checkmark-cover {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1rem;
		height: 1.5rem;
	}
	.choice-option.horizontal .checkmark-cover {
		align-items: center;
	}
	.choice-option.vertical .checkmark-cover {
		position: absolute;
		left: 0.625rem;
		top: 0.375rem;
	}

	/* Checkmark cover items */
	.checkmark-cover .checkmark {
		position: absolute;
		width: 0.875rem;
		min-width: 0.875rem;
	}
	.checkmark-cover .circlemark {
		min-width: 0.5rem;
	}
	.choice-option.descriptions.horizontal.wide .checkmark-cover .checkmark {
		width: 1rem;
		min-width: 1rem;
	}

	.choice-option.horizontal .checkmark-cover {
		height: 1.5rem;
		width: 1.5rem;
		min-width: 1.5rem;
		align-self: center;
	}

	.choice-option.horizontal .option-embed {
		height: 1.15rem;
		width: 1.5rem;
		min-width: 1.5rem;
		padding: 0 0.15rem;
		align-self: center;
	}

	.choice-option.descriptions.horizontal.wide .option-embed,
	.choice-option.descriptions.horizontal.wide .checkmark-cover {
		height: 2rem;
		width: 2rem;
		min-width: 2rem;
		padding: 1px;
	}

	.choice-option.horizontal .option-embed-type-emoji > span {
		font-size: 1.4rem;
		line-height: 1.5rem;
	}

	.choice-option.vertical .option-embed:not(.option-embed-type-image) {
		height: 2.75em;
		width: 80%;
		text-align: center;
		display: flex;
		flex-flow: row;
		align-items: center;
		justify-content: center;
	}

	.choice-option.vertical .option-embed.option-embed-type-image {
		width: 80%;
		text-align: center;
		display: flex;
		flex-flow: row;
		align-items: center;
		justify-content: center;
	}

	.choice-option.vertical .option-embed-type-emoji > span {
		line-height: 2.75rem;
		font-size: 2rem;
	}

	.choice-option.vertical .option-embed-type-svg svg-load {
		display: block;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}

	.choice-option.vertical .option-embed-type-image img {
		width: 100%;
		max-height: 100%;
		object-fit: contain;
	}

	@media (hover: hover) {
		.choice-option:hover .option-embed {
			opacity: 1;
		}
		.choice-option:hover {
			opacity: 1;
			box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
		}
		.choice-option.vertical:hover {
			box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12);
		}
	}
</style>

<script lang="ts">
	export let field: MultipleChoiceField;
	export let active: boolean = false;
	export let option: ChoiceOption = {
		label: "",
		value: ""
	};
	export let opacity: boolean = true;

	import { getImageSrc } from "$lib/helpers/functions";
	import { createEventDispatcher } from "svelte";
	import { draw, fade } from "svelte/transition";

	const dispatch = createEventDispatcher();

	const requestChange = (e: Event) => {
		if (e.target instanceof HTMLInputElement) {
			dispatch("updateValue", {
				active: e.target.checked
			});
		}
	};
</script>

<label
	class:active="{active}"
	class:opacity-true="{opacity}"
	class:descriptions="{field.settings.descriptions ?? false}"
	class:wide="{field.styling.optionsInRow === '1'}"
	class="choice-option {field.styling.vertical === false
		? 'horizontal'
		: 'vertical'}">
	<div class="choice-option-content">
		<input
			type="checkbox"
			checked="{active}"
			on:change="{(e) => requestChange(e)}"
			class="hidden-input"
			value="{option.value}"
			name="{field.id}[]" />
		{#if option.embed}
			<div class="option-embed option-embed-type-{option.embed.type}">
				{#if option.embed.type === "svg"}
					{#key option.embed.content}
						<svg-load
							height="100%"
							max-width="100%"
							max-height="100%"
							src="{getImageSrc(option.embed)}"></svg-load>
					{/key}
				{:else if option.embed.type === "emoji"}
					<span>{@html option.embed.content}</span>
				{:else if option.embed.type === "image"}
					{#key option.embed.content}
						<img
							width="{option.embed.width || 'auto'}"
							height="{option.embed.height || 'auto'}"
							alt="{option.embed.key}"
							src="{getImageSrc(option.embed)}" />
					{/key}
				{/if}
			</div>
		{/if}
		{#if field.styling.vertical || !option.embed}
			<span class="checkmark-cover">
				{#if active}
					<svg
						width="24"
						height="24"
						xmlns="http://www.w3.org/2000/svg"
						class="checkmark"
						viewBox="0 0 24 24">
						<title>Checkmark</title>
						<path
							fill="none"
							stroke="currentColor"
							transition:draw="{{ duration: 200 }}"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2.5"
							d="M5, 13.9l5.2, 4.4l10, -12"></path>
					</svg>
				{:else if field.styling.vertical === false}
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="10"
						height="10"
						fill="none"
						stroke="currentColor"
						stroke-width="16"
						viewBox="0 0 256 256"
						class="circlemark">
						<path
							transition:fade="{{ duration: 200 }}"
							d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z"
						></path>
					</svg>
				{/if}
			</span>
		{/if}
		<div class="choice-option-text">
			<div class="choice-option-text-main">
				{#if option.labelHTML}
					{@html option.labelHTML}
				{:else}
					{option.label}
				{/if}
			</div>
			{#if field.settings.descriptions && option.description}
				<div class="choice-option-text-description">
					{@html option.descriptionComputed ?? option.description}
				</div>
			{/if}
		</div>
	</div>
</label>
